import { toTitleCase } from "../../../../Utils/stringUtls";

const AccountAndInformationOverview = ({ data, type = "debit" }) => {
  const {
    cp_afi_income_account,
    cp_afi_funding_account,
    cp_afi_operating_account,
    cp_afi_inst_name,
    cp_afi_routing_number,
    cp_afi_p_contact_name,
    cp_afi_p_contact_title,
    cp_afi_physical_address,
    cp_afi_phone_number,
    cp_afi_phone_number_country,
    cp_afi_email,
    cp_afi_cpm_pci = "",
  } = data["2_1"];
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid gap-sm" className="">
        <div
          i2c-grid="12@md"
          className="fw-700 review-summary-sub-heading font-bold"
          style={{ marginTop: "16px" }}
        >
          Account & Financial Information
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Income Account</div>
          <div className="overview-val-text">
            {cp_afi_income_account?.length
              ? toTitleCase(cp_afi_income_account)
              : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Funding Account</div>
          <div className="overview-val-text">
            {cp_afi_funding_account?.length
              ? toTitleCase(cp_afi_funding_account)
              : "-"}
          </div>
        </div>

        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Operating Account</div>
          <div className="overview-val-text">
            {cp_afi_operating_account?.length
              ? toTitleCase(cp_afi_operating_account)
              : "-"}
          </div>
        </div>
        <div i2c-grid="12@md">
          <div className="fw-700 review-summary-sub-heading font-bold">
            Financial Information
          </div>
          <p className="mt-0 overview-help-text font-bold">
            Provide details in this section if you are working with an
            intermediary, a direct scheme member (BIN Sponsor)
          </p>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Financial Institution Name
          </div>
          <div className="overview-val-text">
            {cp_afi_inst_name?.length ? toTitleCase(cp_afi_inst_name) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Routing Number</div>
          <div className="overview-val-text">
            {cp_afi_routing_number?.length
              ? cp_afi_routing_number?.toUpperCase()
              : "-"}
          </div>
        </div>

        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Contact Name</div>
          <div className="overview-val-text">
            {cp_afi_p_contact_name?.length
              ? toTitleCase(cp_afi_p_contact_name)
              : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Title</div>
          <div className="overview-val-text">
            {cp_afi_p_contact_title?.length
              ? toTitleCase(cp_afi_p_contact_title)
              : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Phone Number</div>
          <div className="overview-val-text">
            {cp_afi_phone_number?.length ? cp_afi_phone_number : "-"}
          </div>
        </div>

        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Email</div>
          <div className="overview-val-text">
            {cp_afi_email?.length ? toTitleCase(cp_afi_email) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">Physical Address</div>
          <div className="overview-val-text">
            {cp_afi_physical_address?.length
              ? toTitleCase(cp_afi_physical_address)
              : "-"}
          </div>
        </div>
        {type === "credit" ? (
          <div i2c-grid="12@md">
            <div className="fw-700 review-summary-sub-heading font-bold">
              Is the card program manager PCI compliant?{" "}
            </div>
            <p className="mt-0 overview-help-text">
              {cp_afi_cpm_pci?.length
                ? toTitleCase(cp_afi_cpm_pci ?? "-")
                : "-"}
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
};
export default AccountAndInformationOverview;
